<div
  class="relative w-full max-w-[66%] h-full max-h-[66%] aspect-square flex justify-center items-center"
>
  <mat-spinner class="w-full h-full"></mat-spinner>
</div>
